function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _objectSpread({
        viewBox: "0 0 28 28"
    }, props, {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: 14,
                cy: 14,
                r: 14,
                fill: "#EE6D07"
            }),
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_1045_783)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M6.00541 12.5163C6.00541 10.8127 6.00541 9.10915 6.00541 7.41098C6.00541 7.01618 6.07571 6.96751 6.42725 7.14057C7.95777 7.90853 9.48288 8.6765 11.0188 9.43905C11.1702 9.51477 11.2243 9.6013 11.2243 9.76895C11.2189 13.2086 11.2243 16.6482 11.2189 20.0932C11.2189 20.5042 11.0729 20.5908 10.6997 20.4069C9.26655 19.6876 7.83879 18.9737 6.40562 18.2598C6.12439 18.1192 6 17.9191 6 17.6C6.00541 15.9073 6.00541 14.2091 6.00541 12.5163Z",
                        fill: "#0E0E0E"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M16.739 17.5839C15.6303 15.7776 14.5324 13.9929 13.4292 12.2136C13.3534 12.0892 13.3588 11.9973 13.4346 11.8729C14.3972 10.3153 15.3599 8.75235 16.3171 7.18938C16.4199 7.01632 16.5172 6.94601 16.7282 7.04876C18.3074 7.84377 19.8865 8.63337 21.4712 9.42297C21.6496 9.5149 21.6821 9.60144 21.5739 9.7745C19.9839 12.3542 18.3939 14.9339 16.8093 17.5136C16.7931 17.5299 16.766 17.5515 16.739 17.5839Z",
                        fill: "#0E0E0E"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M21.6994 10.5208C21.6994 10.6614 21.6994 10.7479 21.6994 10.8344C21.6994 13.8901 21.6994 16.9403 21.6994 19.9959C21.6994 20.077 21.7048 20.1582 21.694 20.2393C21.6723 20.4502 21.5317 20.5367 21.3316 20.4718C21.2721 20.4502 21.218 20.4178 21.164 20.3907C19.8119 19.7147 18.4599 19.0441 17.1132 18.3681C17.005 18.314 16.8807 18.2923 16.9942 18.1085C18.541 15.6099 20.0823 13.1059 21.6237 10.6019C21.6345 10.5857 21.6453 10.5748 21.6994 10.5208Z",
                        fill: "#0E0E0E"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M16.3734 17.9949C16.2436 17.93 16.1084 17.8597 15.9786 17.7948C14.6374 17.1242 13.2961 16.4535 11.9549 15.7883C11.7764 15.7018 11.6953 15.6099 11.6953 15.3881C11.7061 13.8035 11.7007 12.2189 11.7007 10.6343C11.7007 10.5586 11.7007 10.4775 11.7007 10.4018C11.7169 10.3964 11.7332 10.3909 11.7494 10.3801C13.3015 12.9058 14.8537 15.426 16.4113 17.9516C16.395 17.9732 16.3842 17.9841 16.3734 17.9949Z",
                        fill: "#0E0E0E"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_1045_783",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: 15.7,
                        height: 13.4935,
                        fill: "white",
                        transform: "translate(6 7)"
                    })
                })
            })
        ]
    }));
};
export default Icon;
